export const settingsPageMessages = {
  bulkCreateLinks: 'Bulk Create Links',
  bulkCreateHelp: 'Create up to 100 links from pasted rows',
  rows: 'Rows',
  rowsHint:
    'CSV-style rows: long_url, slug, title, tags. Slug is optional; tags use | or ; between names.',
  parsedRows: '{count} parsed rows',
  enterOneLink: 'Enter at least one link',
  createdLinks: 'Created {count} links',
  createLinks: 'Create Links',
  createdLabel: 'Created',
  webhooks: 'Webhooks',
  webhookLoadFailed: 'Failed to load webhook settings',
  webhookSaved: 'Webhook settings saved',
  webhookDelivered: 'Webhook test delivered',
  enableWebhook: 'Enable webhook delivery',
  webhookUrl: 'Webhook URL',
  signingSecret: 'Signing Secret',
  secretConfigured: 'Secret already configured',
  optional: 'Optional',
  keepSecret: 'Leave blank to keep the current secret.',
  webhookEvents: 'Events',
  healthCheckFailedEvent: 'Health Check Failed',
  healthCheckRecoveredEvent: 'Health Check Recovered',
  saveWebhook: 'Save Webhook',
  sendTest: 'Send Test',
  notificationChannels: 'Notification Channels',
  notificationChannelsHint:
    'Send scheduled original destination/Aff link failure and recovery alerts. Credentials are stored in D1 and never returned by the API.',
  notificationLoadFailed: 'Failed to load notification channels',
  notificationSaved: '{provider} notification settings saved',
  notificationDelivered: '{provider} test notification delivered',
  notificationCredentialCleared: '{provider} credential removed',
  notificationWebhookUrl: 'Official incoming webhook URL',
  telegramBotToken: 'Bot Token',
  telegramChatId: 'Chat ID or @channel',
  configured: 'Configured',
  notConfigured: 'Not configured',
  leaveBlankToKeep: 'Leave blank to keep the stored credential',
  removeCredential: 'Remove Credential',
  dangerZone: 'Danger Zone',
  appearance: 'Appearance',
  integrations: 'Integrations',
  releaseSection: 'Release',
  settingsSections: 'Settings sections',
  resetHelp:
    'Reset this Linketry instance to a clean initial state. Backups and the environment admin token are preserved.',
  resetInstance: 'Reset Instance',
  resetWarning:
    'This deletes links, analytics, domains, tags, imports, API tokens, audit logs, redirect rules, and settings.',
  rowsToRemove: 'Rows to remove',
  noRowsDelete: 'No rows to delete.',
  preResetBackup: 'Create a pre-reset R2 backup before deleting data',
  resetConfirm: 'Type {phrase} to confirm',
  resetComplete: 'Instance reset complete: {rows} rows removed, {keys} cache keys cleared',
  exportCsvHelp: 'All links in CSV format',
  exportJsonHelp: 'All links in JSON format',
  visitsCsvHelp: 'Raw visit records in CSV format',
  fullBackupHelp: 'Links + tags + settings in JSON',
  temporaryApiKey: 'Temporary API key',
  sourcePlaceholder: 'Source',
  displayPreferences: 'Display Preferences',
  displayPreferencesHelp:
    'Tune information density and choose which optional modules appear in navigation.',
  sidebarDensity: 'Sidebar Density',
  tableDensity: 'Table Density',
  comfortable: 'Comfortable',
  compact: 'Compact',
  densityBrowserHint: 'Density preferences are saved only in this browser.',
  optionalModules: 'Optional Advanced Modules',
  optionalModulesHint:
    'Checked modules appear in Advanced navigation. Core links, setup, and settings always remain available.',
  moduleVisibilityInstanceHint:
    'Module visibility is saved for this Linketry instance. Hidden routes remain directly reachable for recovery.',
  saveDisplayPreferences: 'Save Module Visibility',
  displayPreferencesSaved: 'Display preferences saved',
  theme: 'Theme',
  themeHelp: 'Choose the Admin color scheme for this browser.',
  systemTheme: 'System',
  systemThemeHelp: 'Follow your operating system setting and update automatically.',
  lightTheme: 'Light',
  lightThemeHelp: 'Use a bright, high-contrast workspace.',
  darkTheme: 'Dark',
  darkThemeHelp: 'Use the original low-light workspace.',
  quickActions: 'Quick actions',
  switchLanguage: 'Language: {current}. Switch to {next}.',
  switchTheme: 'Switch to {theme} theme.',
  supportEverettlabs: 'Support everettlabs',
} as const;
